export const signupBonus = {
  // アプリ名（Carina/Renka/Sakura等）は applicationId によって変わるため引数で受け取る
  headline: (args: { appName: string | number }) =>
    `${args.appName} へようこそ！`,
  body: (args: { amount: string | number }) =>
    `ご登録ありがとうございます。\n初回登録ボーナスとして${args.amount}ptを\n付与させていただきました。\nたくさん楽しんでください！`,
  unit: "pt",
  autoClose: "数秒後に自動的に閉じます",
  toast: (args: { amount: string | number }) =>
    `${args.amount}pt を獲得しました`,
  close: "閉じる",
  campaignImageAlt: "深田えいみコラボ 初回登録250pt特典",
} as const;
